import React, { useEffect, useRef } from 'react';
import css from './SectionJoinStories.module.css';

/**
 * SectionJoinStories - Widget Join Stories Spotlight
 * Version simplifiée pour debug
 */
const SectionJoinStories = props => {
  const {
    widgetId = 'Cohabs-2',
    widgetUrl = 'https://demo.join-stories.com/widgets/Cohabs-2/index.js',
  } = props;

  const scriptLoadedRef = useRef(false);
  const containerId = `join-widget-${widgetId}`;

  useEffect(() => {
    // Initialize jDataLayer for audience tracking
    if (typeof window !== 'undefined') {
      window.jDataLayer = window.jDataLayer || [];

      if (!window.sendAudienceData) {
        window.sendAudienceData = function(data) {
          window.jDataLayer.push({ type: 'audience', data: data });
        };
      }
    }

    // Load the widget script only once
    if (!scriptLoadedRef.current && typeof document !== 'undefined') {
      const existingScript = document.querySelector(`script[data-join-widget-id="${containerId}"]`);

      if (!existingScript) {
        const script = document.createElement('script');
        script.src = widgetUrl;
        script.type = 'text/javascript';
        script.async = true;
        script.setAttribute('data-join-widget-id', containerId);
        script.setAttribute('data-join-widget-alias', widgetId);

        script.onload = () => {
          console.log('Join Stories script loaded successfully');
        };

        script.onerror = (e) => {
          console.error('Join Stories script failed to load', e);
        };

        document.body.appendChild(script);
        scriptLoadedRef.current = true;
      }
    }

    return () => {};
  }, [widgetId, widgetUrl, containerId]);

  return (
    <div className={css.simpleContainer}>
      <div
        id={containerId}
        style={{ display: 'block', minHeight: '114px', width: '100%' }}
      />
    </div>
  );
};

export default SectionJoinStories;
